import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';

/**
 * Баннер демо-периода: показывается, если у текущего пользователя access_tier=demo.
 */
export default function DemoAccessBanner() {
  const [demo, setDemo] = useState(null);

  useEffect(() => {
    let cancelled = false;
    apiClient
      .get('/users/me')
      .then(({ data }) => {
        if (!cancelled) setDemo(data?.user?.demo || null);
      })
      .catch(() => {
        if (!cancelled) setDemo(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!demo) return null;

  const expired = Boolean(demo.expired);
  const endsLabel = demo.ends_at
    ? new Date(demo.ends_at).toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    : null;

  const usage = demo.usage;
  const limitsText = [
    usage?.campaigns_created != null
      ? `создано кампаний: ${usage.campaigns_created}/${demo.max_campaigns}`
      : demo.max_campaigns != null
        ? `создание кампаний ≤ ${demo.max_campaigns}`
        : null,
    demo.max_nms != null ? `артикулов воронки ≤ ${demo.max_nms}` : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <div
      role="status"
      className={`px-4 py-2.5 text-sm border-b ${
        expired
          ? 'bg-[var(--wb-danger-bg)] text-[var(--wb-danger)] border-[var(--wb-danger)]/20'
          : 'bg-amber-50 text-amber-950 border-amber-200'
      }`}
    >
      <div className="max-w-6xl mx-auto flex flex-wrap items-center gap-x-3 gap-y-1">
        <span className="font-semibold shrink-0">
          {expired ? 'Демо-период истёк' : 'Демо-доступ'}
        </span>
        <span className="opacity-90">
          {expired
            ? 'Доступен просмотр. Создание кампаний и изменения недоступны — оформите полный доступ.'
            : `Рабочий доступ через WB API с лимитами${endsLabel ? ` до ${endsLabel}` : ''}${
                demo.days_left != null ? ` (осталось ${demo.days_left} дн.)` : ''
              }.`}
        </span>
        {limitsText && <span className="text-xs opacity-80 w-full sm:w-auto">{limitsText}</span>}
      </div>
    </div>
  );
}
